























import { defineComponent, PropType, toRef } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import useModal from "@/hooks/useModal";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";

export default defineComponent({
  name: "BaseConfirm",
  components: { BaseIcon, CustomScroll },
  props: {
    title: { type: String as PropType<TranslateResult> },
    scrollable: { type: Boolean, default: true },
    classWrapper: { type: String },
    closable: { type: Boolean, default: true },
    value: { type: Boolean, required: true },
    clearStatus: { type: Boolean, default: true },
  },
  setup(props) {
    const { modalClose } = useModal(toRef(props, "value"), props.closable, props.clearStatus);

    return {
      modalClose,
    };
  },
});
